import React from "react";
import Div from "@jumbo/shared/Div";
import { Typography } from "@mui/material";

import $ from 'jquery';
import { useProgram } from "app/hooks/useProgram";
import moment from "moment";

const TncViewer = ({ content = "", date = "", batchNo="1" }) => {
  const program = useProgram();

  React.useEffect(() => {
    setTimeout(() => {
      $('p').each(function () {
        var $this = $(this);
        if ($this.html().replace(/\s|&nbsp;/g, '').length == 0)
          $this.remove();
        // $this.addClass('p-blank');
      });
    }, 500);
  }, [])


  return (
    <Div className='mt-2'>
      <Div className='p-4 tnc-content'>
        <Typography fontSize={14} mb={2}><span style={{ fontStyle: "italic" }}>{program}</span>  adalah program yang diselenggarakan oleh PT Asuransi Jiwa Generali Indonesia (“<span style={{ fontWeight: "bold" }}>Perusahaan</span>”) untuk membantu Agen Perusahaan dalam meningkatkan penjualannya melalui referensi penjualan produk yang diperoleh dari jaringan sosial Agen tersebut secara digital. Sebagai syarat keikutsertaan <span style={{ fontStyle: "italic" }}>{program}</span>, calon Pemberi Referensi (<span style={{ fontStyle: "italic" }}>Referrer</span>) di dalam <span style={{ fontStyle: "italic" }}>{program}</span> wajib untuk menyetujui syarat dan ketentuan yang telah ditetapkan oleh Perusahaan.</Typography>
        <Typography fontSize={14} mb={2} dangerouslySetInnerHTML={{ __html: content }}></Typography>
        
        <Typography fontSize={14} fontWeight="bold">Syarat dan Ketentuan Referral Booster ini disetujui pada tanggal {date ? moment(date).format('DD/MM/YYYY'):'.............'}</Typography>
        <br></br>
        <Typography align="right" fontSize={14} fontWeight="bold">Versi {batchNo}</Typography>
      </Div>
    </Div>
  )
}

export default TncViewer;